<template>
  <div id="main">
    
    <navatras-app :linksPath='linksPath'></navatras-app>

    <!-- Contenidos -->
    <img id="content-label" v-focus class="offscreen" tabindex="0" alt="Contenido. Se sugiere navegar con las flechas del teclado.">
    <component :is="'davivienda'+$route.params.unipage+'-app'"></component>

    <navadel-app :linksPath='linksPath'></navadel-app>
  </div>
</template>

<script>
// Importar páginas internas
import Davivienda01 from "./davivienda-01.vue";
import Davivienda02 from "./davivienda-02.vue";
import Davivienda03 from "./davivienda-03.vue";
import Davivienda04 from "./davivienda-04.vue";
import Davivienda05 from "./davivienda-05.vue";
import Davivienda06 from "./davivienda-06.vue";
import Davivienda07 from "./davivienda-07.vue";
import Davivienda08 from "./davivienda-08.vue";
import Davivienda09 from "./davivienda-09.vue";
import Davivienda10 from "./davivienda-10.vue";
import Davivienda11 from "./davivienda-11.vue";
import Davivienda12 from "./davivienda-12.vue";
import Davivienda13 from "./davivienda-13.vue";
import Davivienda14 from "./davivienda-14.vue";
import Davivienda15 from "./davivienda-15.vue";
import Davivienda16 from "./davivienda-16.vue";
import Davivienda17 from "./davivienda-17.vue";
import Davivienda18 from "./davivienda-18.vue";
import Davivienda19 from "./davivienda-19.vue";
import Davivienda20 from "./davivienda-20.vue";
import Davivienda21 from "./davivienda-21.vue";
import Davivienda22 from "./davivienda-22.vue";
import Davivienda23 from "./davivienda-23.vue";
import Davivienda24 from "./davivienda-24.vue";
import Davivienda25 from "./davivienda-25.vue";
import Davivienda26 from "./davivienda-26.vue";
import Davivienda27 from "./davivienda-27.vue";
import Davivienda28 from "./davivienda-28.vue";
import Davivienda29 from "./davivienda-29.vue";
import Davivienda30 from "./davivienda-30.vue";
import Davivienda31 from "./davivienda-31.vue";
import Davivienda32 from "./davivienda-32.vue";
import Davivienda33 from "./davivienda-33.vue";
import Davivienda34 from "./davivienda-34.vue";
import Davivienda35 from "./davivienda-35.vue";
import Davivienda36 from "./davivienda-36.vue";
import Davivienda37 from "./davivienda-37.vue";
import Davivienda38 from "./davivienda-38.vue";
import Davivienda39 from "./davivienda-39.vue";
import Davivienda40 from "./davivienda-40.vue";
import Davivienda41 from "./davivienda-41.vue";
import Davivienda42 from "./davivienda-42.vue";
import Davivienda43 from "./davivienda-43.vue";
import Davivienda44 from "./davivienda-44.vue";
import Davivienda45 from "./davivienda-45.vue";
import Davivienda46 from "./davivienda-46.vue";
import Davivienda47 from "./davivienda-47.vue";
import Davivienda48 from "./davivienda-48.vue";
import Davivienda49 from "./davivienda-49.vue";
import Davivienda50 from "./davivienda-50.vue";
import Davivienda51 from "./davivienda-51.vue";
import Davivienda52 from "./davivienda-52.vue";
import Davivienda53 from "./davivienda-53.vue";
import Davivienda54 from "./davivienda-54.vue";
import Davivienda55 from "./davivienda-55.vue";
import Davivienda56 from "./davivienda-56.vue";
import Davivienda57 from "./davivienda-57.vue";

export default {
  components: {
    "davivienda1-app": Davivienda01,
    "davivienda2-app": Davivienda02,
    "davivienda3-app": Davivienda03,
    "davivienda4-app": Davivienda04,
    "davivienda5-app": Davivienda05,
    "davivienda6-app": Davivienda06,
    "davivienda7-app": Davivienda07,
    "davivienda8-app": Davivienda08,
    "davivienda9-app": Davivienda09,
    "davivienda10-app": Davivienda10,
    "davivienda11-app": Davivienda11,
    "davivienda12-app": Davivienda12,
    "davivienda13-app": Davivienda13,
    "davivienda14-app": Davivienda14,
    "davivienda15-app": Davivienda15,
    "davivienda16-app": Davivienda16,
    "davivienda17-app": Davivienda17,
    "davivienda18-app": Davivienda18,
    "davivienda19-app": Davivienda19,
    "davivienda20-app": Davivienda20,
    "davivienda21-app": Davivienda21,
    "davivienda22-app": Davivienda22,
    "davivienda23-app": Davivienda23,
    "davivienda24-app": Davivienda24,
    "davivienda25-app": Davivienda25,
    "davivienda26-app": Davivienda26,
    "davivienda27-app": Davivienda27,
    "davivienda28-app": Davivienda28,
    "davivienda29-app": Davivienda29,
    "davivienda30-app": Davivienda30,
    "davivienda31-app": Davivienda31,
    "davivienda32-app": Davivienda32,
    "davivienda33-app": Davivienda33,
    "davivienda34-app": Davivienda34,
    "davivienda35-app": Davivienda35,
    "davivienda36-app": Davivienda36,
    "davivienda37-app": Davivienda37,
    "davivienda38-app": Davivienda38,
    "davivienda39-app": Davivienda39,
    "davivienda40-app": Davivienda40,
    "davivienda41-app": Davivienda41,
    "davivienda42-app": Davivienda42,
    "davivienda43-app": Davivienda43,
    "davivienda44-app": Davivienda44,
    "davivienda45-app": Davivienda45,
    "davivienda46-app": Davivienda46,
    "davivienda47-app": Davivienda47,
    "davivienda48-app": Davivienda48,
    "davivienda49-app": Davivienda49,
    "davivienda50-app": Davivienda50,
    "davivienda51-app": Davivienda51,
    "davivienda52-app": Davivienda52,
    "davivienda53-app": Davivienda53,
    "davivienda54-app": Davivienda54,
    "davivienda55-app": Davivienda55,
    "davivienda56-app": Davivienda56,
    "davivienda57-app": Davivienda57,
  },
  data() {
    return {
      headcol: "",
    };
  },
  computed: {
    currentPage() {
      return Math.floor(this.$route.params.unipage);
    },
    linksPath(){
      return this.$store.state.linksPath;
    }
  },
  mounted() {
    this.$store.commit("screenTrack", [this.currentPage, 57]);
  },
  updated() {
    this.$store.commit("screenTrack", [this.currentPage, 57]);
  }
};
</script>

<style lang='scss' scoped>
.notshow {
  display: none;
}
</style>



// WEBPACK FOOTER //
// davivienda.vue?36bd4e52